import { FormikProps } from "formik";
import { useContext } from "react";
import {
  ProgramReportInfo,
  SubmitProgramReport,
} from "../../../../../generated/data-contracts";
import { AvisUtils, TimeUtils } from "../../../../../utils";
import { AvisSection, AvisValueRow } from "../../../../shared/components/form";
import { AvisInputText } from "../../../../shared/components/inputs";
import { AvisContext } from "../../../../shared/context/AvisContext";

interface IProgramReportHeaderProps {
  bag: FormikProps<SubmitProgramReport>;
  data: ProgramReportInfo | undefined;
}
export function ProgramReportHeader(
  props: Readonly<IProgramReportHeaderProps>,
) {
  const { bag, data } = props;
  const { res } = useContext(AvisContext);

  const editAllowed = AvisUtils.isEditablePortalReportStatusTypeInfo(
    data?.portalReportStatusType,
  );
  return (
    <AvisSection classNameIn="program-report-details">
      <AvisValueRow
        rowTitle={res("licensees_LicenseReports_PP_label_ReportFor")}
        rowValue={data?.licenseNumber}
      />
      <AvisValueRow
        rowTitle={res("licensees_LicenseReports_PP_label_EventDate")}
        rowValue={TimeUtils.formatUTCDateString(data?.eventDate)}
      />
      <AvisValueRow
        rowTitle={res("licensees_LicenseReports_PP_label_EventTitle")}
        rowValue={<div>{data?.eventName}</div>}
      />
      <AvisValueRow
        rowTitle={res("licensees_LicenseReports_PP_label_EventLocation")}
        rowValue={
          <AvisInputText<SubmitProgramReport>
            bag={bag}
            bagField="eventLocation"
            className="input-event-location"
            maxLength={1000}
            disabled={!editAllowed}
            hideClear
          />
        }
      />
    </AvisSection>
  );
}
